"use client"

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NuisibleService } from '../../../lib/api/services/nuisible.service';

const nuisibleService = new NuisibleService();

export function useDeleteNuisible() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => nuisibleService.deleteNuisible(id),
    onSuccess: () => {
      // Invalidate and refetch nuisibles list
      queryClient.invalidateQueries({ queryKey: ['nuisibles'] });
    },
  });
}